import { ConditionalSettingsValue, WidgetConfiguration } from './types';

export function parseConditionalDefaults(selectOptions: ConditionalSettingsValue[]): WidgetConfiguration {
    const conditionalConfigurations: WidgetConfiguration = {};
    selectOptions.forEach(
        (option): void => {
            if (option && option.settings) {
                option.settings.forEach(
                    (conditionalSetting): void => {
                        conditionalConfigurations[conditionalSetting.id] = conditionalSetting.default;
                    }
                );
            }
        }
    );

    return conditionalConfigurations;
}
